import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5bb24e72")

_pushScopeId("data-v-5bb24e72")
const _hoisted_1 = {
  id: "STI",
  class: "relative bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen w-full"
}
const _hoisted_2 = { class: "flex flex-row py-6 align-middle items-center justify-between w-full" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout flex flex-row align-middle justify-center" }
const _hoisted_4 = {
  class: "mr-8",
  style: {"align-self":"center"}
}
const _hoisted_5 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Print = _resolveComponent("Print")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: ["flex flex-col justify-between items-start border-b border-gray-lp-400 z-20 relative pt-8", _ctx.isSidebarAndBreadcrumbV2 ? 'pt-4' : 'pt-8']
      }, [
        _createVNode(_component_Breadcrumb),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("sti.pageTitle")), 1),
            _createVNode(_component_Search, {
              class: "w-64 self-center",
              onInput: _ctx.onSearch,
              onClear: _ctx.clearSearch,
              value: _ctx.searchValue,
              placeholder: _ctx.$t('sti.searchPlaceholder'),
              minChar: 1,
              timeout: 1000
            }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
            _createVNode(_component_time_range_picker, {
              startDate: _ctx.periodeStart,
              endDate: _ctx.periodeEnd,
              onSelect: _ctx.setPeriode,
              default: _ctx.$t('sti.timeRangeDefault')
            }, null, 8, ["startDate", "endDate", "onSelect", "default"])
          ]),
          (_ctx.ableToCreate)
            ? (_openBlock(), _createBlock(_component_lp_button, {
                key: 0,
                onClick: _ctx.goToUpdate,
                title: _ctx.$t('sti.updateButton'),
                textColor: "white"
              }, null, 8, ["onClick", "title"]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createVNode(_component_TableV2, {
        "data-testid": "outgoing-sti-list-table",
        columns: _ctx.columns,
        data: _ctx.STIList,
        loading: _ctx.isLoading,
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
        onRequest: _ctx.fetchSTIList,
        onClick: _ctx.goToDetail,
        isDetailAble: _ctx.ableToDetail,
        errorCause: _ctx.errorCause,
        totalColumnFreeze: 1
      }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "onClick", "isDetailAble", "errorCause"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ])
  ], 64))
})